import { Observable } from 'rxjs/Observable';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ProgramStatementsModel } from './models/program-statements.model';
import { Injectable } from '@angular/core';
import { EnrollmentProgramsService } from './services/enrollment-programs.service';
import { AuthService } from '../auth/auth.service';
import { SecurityService } from '../security/security.service';
@Injectable()
export class AppStatementsResolver implements Resolve<ProgramStatementsModel> {

  constructor(private programsService:EnrollmentProgramsService, private authService:AuthService, private securityService:SecurityService) {}

  resolve(route: ActivatedRouteSnapshot) {
    
    if(route.params['type'])
        return this.programsService.getProgramStatements(route.params['type'])
        .catch((e)=>{
          this.authService.toastr.error('Error in resolving program statements');
          return Observable.of(e);
        });
    else
        return Observable.of<ProgramStatementsModel>(null);
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/app-statements.resolver.ts